// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"179":"rule","826":"index","914":"records"}[chunkId] || chunkId) + "." + {"179":"0e2fb","480":"4915d","826":"f5746","914":"faa5e"}[chunkId] + ".js";
};